"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var dealInfoHelpers = tslib_1.__importStar(require("../../utils/deal-info-helpers"));
function isSaleEnabled(video) {
    return Boolean(video && dealInfoHelpers.getSalePriceInfo(video.dealInfo || []));
}
exports.isSaleEnabled = isSaleEnabled;
function isRentEnabled(video) {
    return Boolean(video && dealInfoHelpers.getRentPriceInfo(video.dealInfo || []));
}
exports.isRentEnabled = isRentEnabled;
function isBought(video) {
    return Boolean(lodash_1.get(video, 'dgsInfo.sale'));
}
exports.isBought = isBought;
function isRented(video) {
    return Boolean(lodash_1.get(video, 'dgsInfo.rent'));
}
exports.isRented = isRented;
function isOwned(video) {
    return isRented(video) || isBought(video);
}
exports.isOwned = isOwned;
function isFree(video) {
    return !isSaleEnabled(video) && !isRentEnabled(video);
}
exports.isFree = isFree;
//# sourceMappingURL=pricing.js.map